import {AppFunction} from "../misc/types";
import View from "../framework/view";
import template from "../../pugc/about-the-project";

export class AboutProjectFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new AboutProjectView();
    }

    view() {
        return this.v;
    }
    url() {
        return "/project";
    }

    offlineEnabled() {
        return true;
    }
}

class AboutProjectView extends View {

    static classname = "about-the-project-view";

    constructor() {
        super(AboutProjectView.classname);
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
        };

        const out = this.pug(template, data);

        return out;
    }

}

